export const APPLICANT_PROFILE_TAB = {
  documents: 'documents',
  overview: 'overview',
  updates: 'updates',
}

export const QA_NAME_APPLICANT_PROFILE_TAB_DOCUMENTS =
  'applicantProfileDocumentsTab'

export const QA_NAME_APPLICANT_PROFILE_TAB_OVERVIEW =
  'applicantProfileOverviewTab'

export const QA_NAME_APPLICANT_PROFILE_TAB_UPDATES =
  'applicantProfileUpdatesTab'

export const QA_NAME_APPLICANT_PROFILE_TABS = 'applicantProfileTabs'

// TODO: the e-mails, viewings and compliance tabs come with their backend reads
export const APPLICANT_PROFILE_TAB_LIST = [
  {
    id: APPLICANT_PROFILE_TAB.overview,
    qaName: QA_NAME_APPLICANT_PROFILE_TAB_OVERVIEW,
    titleKey: 'RentalPortal.ListingProfileTabOverviewKey',
  },
  {
    id: APPLICANT_PROFILE_TAB.documents,
    qaName: QA_NAME_APPLICANT_PROFILE_TAB_DOCUMENTS,
    titleKey: 'RentalPortal.ListingProfileTabDocumentsKey',
  },
  {
    id: APPLICANT_PROFILE_TAB.updates,
    qaName: QA_NAME_APPLICANT_PROFILE_TAB_UPDATES,
    titleKey: 'RentalPortal.ListingProfileTabUpdatesKey',
  },
]
